import * as types from '../constants/action.types';
import { IAction } from '../constants/action';
import { categoryArticlesState } from '../constants/initial-state';

export default function downloadsReducer(state = categoryArticlesState, action: IAction) {
    switch (action.type) {
        case (types.CAT_ARTICLES_REQUESTED):
            return Object.assign({}, state, { isFetching: true });
        case (types.CAT_ARTICLES_FAILED):
            return Object.assign({}, state, { isFetching: false, error: action.data });
        case (types.CAT_ARTICLES_RETRIEVED):
            const data = action.data.items instanceof Array ? action.data.items : [];
            state.categories[data.category] = {
                items: data,
                total: data.length
            };
            const categories = Object.assign({}, state.categories);
            return Object.assign({}, state, { isFetching: false, loaded: true, categories, activeCategory: data.category });
        case (types.CAT_ARTICLES_CHANGE_PAGE):
            return Object.assign({}, state, { page: action.data });
        case (types.CHANGE_CATEGORY):
            return Object.assign({}, state, { activeCategory: action.data });
        default: return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/category-articles.reducer.ts